import React from 'react';

function DiagnosesSection({ formData, handleChange, diagnosisOptions }) {
  const opts = diagnosisOptions || [];
  return (
    <div className="form-section">
      <h3 className="section-title">Diagnoses</h3>
      <div className="form-grid form-grid-3">
        <div className="form-group">
          <label htmlFor="diagnosis_1_id">Diagnosis Dx1</label>
          <select
            id="diagnosis_1_id"
            name="diagnosis_1_id"
            value={formData.diagnosis_1_id || ''}
            onChange={handleChange}
          >
            <option value="">—</option>
            {opts.map((item) => (
              <option key={item.id} value={item.id}>
                {item.description || item.code || item.id}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="diagnosis_2_id">Diagnosis Dx2</label>
          <select
            id="diagnosis_2_id"
            name="diagnosis_2_id"
            value={formData.diagnosis_2_id || ''}
            onChange={handleChange}
          >
            <option value="">—</option>
            {opts.map((item) => (
              <option key={item.id} value={item.id}>
                {item.description || item.code || item.id}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="diagnosis_3_id">Diagnosis Dx3</label>
          <select
            id="diagnosis_3_id"
            name="diagnosis_3_id"
            value={formData.diagnosis_3_id || ''}
            onChange={handleChange}
          >
            <option value="">—</option>
            {opts.map((item) => (
              <option key={item.id} value={item.id}>
                {item.description || item.code || item.id}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default DiagnosesSection;
